import { render } from "./AddChampsLibreFamillePage.vue?vue&type=template&id=aace49a2&ts=true"
import script from "./AddChampsLibreFamillePage.vue?vue&type=script&lang=ts"
export * from "./AddChampsLibreFamillePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__